<template>
    <EChart
        card
        class="mt-3"
        :options="chartOptions"
        :header="$t('sales')"
        :error="requestChart.getError()"
        :loading="loading"
        type="time"
    >
        <template #nav>
            <div class="d-flex gap-3">
                <FormCategoryTreeSelect
                    ref="FormCategoryTreeSelect"
                    v-model="categories"
                    :disabled="requestChart.getLoading()"
                    class="width-200"
                    preselect
                    prevent-empty-selection
                    :clearable="false"
                    @loading="categoriesLoading = $event"
                />
            </div>
        </template>
    </EChart>
</template>



<script>
    import { generateEChartData } from '@/utils/chart';
    import EChart from '@/components/common/EChart.vue';
    import FormCategoryTreeSelect from '@/components/common/FormCategoryTreeSelect.vue';

    export default {
        name: 'SalesChart',
        components: {
            EChart,
            FormCategoryTreeSelect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.$req('space/SalesChart'),
                categories: [],
                categoriesLoading: false,
            };
        },
        computed: {
            loading() {
                return this.requestChart.getLoading() || this.categoriesLoading;
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const { startDate, endDate } = this.timeRange;
                const requestParams = { startDate, endDate };
                if (this.categories?.length) requestParams.categories = this.categories.join(',');
                return { urlParams, requestParams };
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartOptions() {
                if (!this.chartData.length) {
                    return { series: [] };
                }
                const chartData = this.chartData.reduce(
                    (acc, item) => {
                        acc.amount.push([item.date, item.amount]);
                        acc.quantity.push([item.date, item.quantity]);
                        return acc;
                    },
                    { amount: [], quantity: [] }
                );

                return {
                    yAxis: [
                        {
                            type: 'value',
                            name: this.$t('dashboard.quantity'),
                        },
                        {
                            type: 'value',
                            name: this.$t('dashboard.salesAmount'),
                            position: 'right',
                        },
                    ],
                    series: [
                        {
                            name: this.$t('dashboard.quantity'),
                            type: 'line',
                            data: generateEChartData(this.timeRange, chartData.quantity),
                            areaStyle: null,
                        },
                        {
                            name: this.$t('dashboard.salesAmount'),
                            type: 'bar',
                            yAxisIndex: 1,
                            data: generateEChartData(this.timeRange, chartData.amount),
                            tooltip: {
                                valueFormatter: value => this.$format.currency(value),
                            },
                        },
                    ],
                };
            },
        },
        watch: {
            apiParams: {
                handler(newVal, oldVal) {
                    if (JSON.stringify(newVal || {}) !== JSON.stringify(oldVal || {})) {
                        this.loadData();
                    }
                },
            },
        },
        methods: {
            loadData() {
                this.fetchChart();
            },
            fetchChart() {
                this.requestChart.get(this.apiParams);
            },
        },
    };
</script>
